import { debounce } from 'lodash';

import { SET_ACTIVE_DAY } from '../constants';

const DEBOUNCE_TIMEOUT = 200;

// Prevent SET_ACTIVE_DAY firing twice when clicking "next available
// time" button if next available time is not in same week that is
// currently rendered, and thus preventing selecting proper next
// available day
const debounceSetActiveDay = () => (next) => {
  const debounced = debounce(next, DEBOUNCE_TIMEOUT, { leading: true, trailing: false });
  return (action) => {
    if (action.type !== SET_ACTIVE_DAY) return next(action);

    return debounced(action);
  };
};

export default debounceSetActiveDay;



// WEBPACK FOOTER //
// ./src/app/middlewares/debounceSetActiveDay.js